import {Board, BoardHeader, BoardTableContainer} from "../../assets/GlobalStyles";
import React, {useCallback, useEffect, useState} from "react";
import {useAtom} from "jotai";
import Table from "../../components/table";
import {accountHistoryColumns, accountHistoryDataAtom, accountHistorySetting, searchAccountParams} from "./entity";
import {accountHistoryTableData} from "../../services/account/AccountAdminAxios";
import {ToastContainer} from "react-toastify";
import {tokenResultAtom} from "../login/entity";
import {AdminInfo} from "../layout";
import {userAccountHistoryTableData} from "../../services/account/AccountUserAxios";
import {AccountCondition} from "../../components/Account/Condition";


export default function AccountHistory() {
  const [tokenResultInfo] = useAtom(tokenResultAtom)
  const [adminInfoState] = useAtom(AdminInfo) //매체 전환 계정 정보
  const [accountHistoryDataState, setAccountHistoryDataState] = useAtom(accountHistoryDataAtom)
  const [searchAccountHistoryParamsState, setSearchAccountHistoryParamsState] = useState(searchAccountParams)

  const handleHistoryTableData = useCallback(async () => {
    if (tokenResultInfo.role !== 'NORMAL') {
      const userName = adminInfoState.convertedUser !== ''
          ? adminInfoState.convertedUser
          : '';

      accountHistoryTableData(userName, searchAccountHistoryParamsState).then(response => {
        if (response !== null) {
          setAccountHistoryDataState(response);
        }
      });

      return;
    }

    userAccountHistoryTableData(
        tokenResultInfo.username,
        searchAccountHistoryParamsState
    ).then(response => {
      if (response !== null) {
        setAccountHistoryDataState(response);
      }
    });
  }, [
    adminInfoState.convertedUser,
    searchAccountHistoryParamsState,
    setAccountHistoryDataState,
    tokenResultInfo.role,
    tokenResultInfo.username,
  ]);

  useEffect(() => {
    handleHistoryTableData();
  }, [handleHistoryTableData]);
  return (
    <>
      <Board>
        <BoardHeader>정산 이력</BoardHeader>
        <AccountCondition handleHistoryTableData={handleHistoryTableData} searchAccount={searchAccountHistoryParamsState} setSearchAccount={setSearchAccountHistoryParamsState} />
        <BoardTableContainer>
          <Table columns={accountHistoryColumns}
                 data={accountHistoryDataState}
                 settings={accountHistorySetting}
                 showHoverRows={false}
                 activeCell={[0]}
                 emptyText={'정산 이력 내역이 없습니다.'}/>
        </BoardTableContainer>
      </Board>
      <ToastContainer position="top-center"
                      autoClose={1500}
                      hideProgressBar
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      limit={1}
                      style={{zIndex: 9999999}}/>
    </>
  )
}
